"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ReactDOM = require("react-dom");
var Dialog_1 = require("../Dialog");
var DialogService = /** @class */ (function () {
    function DialogService() {
        var _this = this;
        this.dialog = null;
        ReactDOM.render(React.createElement(Dialog_1.default, { ref: function (el) { _this.dialog = el; } }), document.createElement('div'));
    }
    DialogService.getInstance = function () {
        if (this.serviceInstance == null) {
            this.serviceInstance = new DialogService();
        }
        return this.serviceInstance;
    };
    DialogService.prototype.show = function (options) {
        return this.dialog.show(options);
    };
    DialogService.serviceInstance = null;
    return DialogService;
}());
exports.default = DialogService;
//# sourceMappingURL=DialogService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Dialog/service/DialogService.js
// module id = 518
// module chunks = 8